import useReactHookForm from "hooks/useReactHookForm";
import { hasAtLeastOneValue, VenProUsersInitialValues, VenProUsersValidationSchema, VenProUsersProperties } from "./helper";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { Button, Grid, Paper } from "@mui/material"
import { useEffect } from "react";
import { GET_VENDOR_PROJECT_USERS, GET_VENDOR_USERS } from "utils/graphql/services/live-classes/queries";
import liveClassClientService from "utils/graphql/liveclassClient";
import { useLazyQuery } from "@apollo/client";
import { useAppDispatch } from "hooks/redux";
import { useHistory } from "react-router-dom";
import { metadataUpdate } from "app-component/slices/metadata-slice";
import { formatDateUtc } from "utils/time-util/utcIstTime";

export function VendorProjectUserFilter({ setSearchPayload,
  setPage,
  clearValuesTrigger }) {


  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    VenProUsersInitialValues,
    VenProUsersValidationSchema,
    "",
  );

  const handleSearch = () => {
    const payload: any = {};

    const projectId = watch("projectId");
    if (projectId) payload.projectId = parseInt(projectId);

    const vendorUserId = watch("vendorUserId");
    if (vendorUserId) payload.vendorUserId = parseInt(vendorUserId);

    // const externalUserId= watch("externalUserId");
    // if(externalUserId) payload.externalUserId=parseInt(externalUserId);

    const userType = watch("userType");
    if (userType) payload.userType = userType;

    const isUsed = watch("isUsed");
    if (isUsed === "true") payload.isUsed = true;
    else if (isUsed === "false") payload.isUsed = false;

    const isActive = watch("isActive");
    if (isActive === "true") payload.isActive = true;
    else if (isActive === "false") payload.isActive = false;

    const createdAt = watch("created_at");
    if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
    if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if (updatedAt?.[0]) payload.updatedFrom = formatDateUtc(updatedAt[0]);
    if (updatedAt?.[1]) payload.updatedTill = formatDateUtc(updatedAt[1], true);

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () => {
    setValue("projectId", "");
    setValue("vendorUserId", "");
    // setValue("externalUserId","");
    setValue("userType", "");
    setValue("isUsed", "");
    setValue("isActive", "");
    setValue("created_at", [null, null]);
    setValue("updated_at", [null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(() => {
    clearFilter()
  }, [clearValuesTrigger])

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={VenProUsersProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["projectId", "vendorUserId", "userType", "isUsed", "isActive", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["projectId", "vendorUserId", "userType", "isUsed", "isActive", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
